import { SITE } from "@/config/site.config";

/**
 * Resolve a public asset path for wherever the site is deployed.
 *
 * The base path comes from `REACT_APP_BASE_PATH` (see src/config/site.config.js). When it
 * is not set we fall back to sniffing the URL, so an unconfigured build dropped into a
 * /snapx subfolder still resolves its assets correctly.
 */
const detectedBase = () => {
  if (typeof window === "undefined") return "";
  const match = window.location.pathname.match(/^\/(snapx)(?=\/|$)/);
  return match ? `/${match[1]}` : "";
};

export const basePath = () => SITE.basePath || detectedBase();

export const asset = (path) => {
  if (!path) return "";
  if (/^(https?:)?\/\//.test(path) || path.startsWith("data:")) return path;
  const clean = path.startsWith("/") ? path : `/${path}`;
  return `${basePath()}${clean}`;
};
